'use strict';

import { io, sub, base, Component, PropTypes, cloneElement } from 'core';

import $style from './section.styl';

@base({
    styles: [ $style ]
})
class HSSection extends Component {

    onResize = (e) => {

        const width = $(window).width();
        const factor = width > 400 ? 0.8 : 0.96

        const final = width * factor;

        $(this.refs.section.getDOMNode())
              .width(final);

        io.emit('section:resized', final);
    }
    componentWillUnmount() {

        $(window).off('resize', this.onResize);

        [0, 10].forEach((t) =>
            setTimeout(() => io.emit('section:mounted'), t));
    }
    componentDidMount() {

        io.emit('section:mounted');

        $(window).on('resize', this.onResize);

        this.onResize();
    }

    render() {

        var sectionClass = "section";

  		return (
  			<div ref="section" className={sectionClass}>
                {this.props.children}
  			</div>
  		);
	}
}

export default HSSection



// WEBPACK FOOTER //
// ./ui/c/layout/hsLayout/section.jsx